export enum SalesOrganizationType {
  YDDOB = 'f31c7fb8-6be0-4be0-b0cf-4e6993836531',
  PALEX = 'e3c7c999-47d3-4fed-aa82-4e3a32dad162',
  ICL = '9f4637e4-c83e-4647-8189-14cf09489284',
  NGF = '2186d426-3b2a-486a-b482-4d87f84c70c3',
}
